import { useEffect, useState } from "react";
import AlertSmall from "../../AlertSmall";
import OrderSummaryTable from "./OrderSummaryTable"; // Import the new component

export function OrderSummary({ order, isApprovalRequest, orderActions, product, customer }) {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    setAlerts(getAlerts());
  }, [order, product]);

  const getAlerts = () => {
    const alerts = [];
    if (order?.totalInitialPrice > customer.vbCustomer?.creditLimit && !order.hasCreditLimitExemption) {
      alerts.push({
        type: 'warning',
        title: 'Orderläggningen är över kreditgränsen och kommer behöva godkännas av ekonomiavdelningen.',
      });
    }
    return alerts;
  };

  const onOrderLineEdit = (orderline) => {
    orderActions.editOrderline(orderline, order.customerNumber, order.orderId);
  };

  const onOrderLinesRemove = (orderlineIds) => {
    orderActions.removeOrderLines(order.orderId, orderlineIds, order.customerNumber);
  };

  return <>
    {alerts.map((alert, index) => (
      <AlertSmall key={index} alert={alert} />
    ))}
    <OrderSummaryTable order={order} isApprovalRequest={isApprovalRequest} onEdit={onOrderLineEdit} onRemove={onOrderLinesRemove} />
  </>
}